import React from 'react'

const HeroImage = ({img}) => {
  return (
    <div className='Hero-image-wrapper'>
      <img src={img}/>
    </div>
  )
}

export default HeroImage
